<template>
  <FormItem :label="label" :border="border" :required="required">
    <div class="please-select flex flex-1 items-center justify-end overflow-hidden">
      <div class="truncate" @click="onClick">
        <span v-if="!name" style="color:#888"> 请选择 </span>
        <span v-else style="color:#333"> {{ name }} </span>
      </div>
      <van-icon name="arrow" color="#999999" size="12" />
    </div>
  </FormItem>
</template>

<script setup>
import FormItem from "./FormItem.vue";
defineProps({
  label: { type: String, default: "" },
  border: {
    type: Boolean,
    default: true
  },
  required: {
    type: Boolean,
    default: false
  },
  name: { type: String, default: "" }
});

const emit = defineEmits(["click"]);

const onClick = () => emit("click");
</script>
<style lang="less" scoped>
.please-select {
  padding-left: 20px;
  .truncate {
    margin-right: 10px;
  }
}
</style>
